import type { GridFilterOperator } from '@packages/fenrir/components/datagrid';

import type { MultiSelectOption } from './multi-select-filter-input';
import { MultiSelectFilterInput } from './multi-select-filter-input';

export const getHaveAnyOfFilterOperator = (
  options: MultiSelectOption[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): GridFilterOperator<any, string[]>[] => {
  return [
    {
      value: 'haveAnyOf',
      label: 'Have Any Of',
      getApplyFilterFn: (filterItem) => {
        if (filterItem.value === undefined || filterItem.value.length === 0) {
          return null;
        }
        return (value: string[]) => {
          return value.some((v: string) =>
            filterItem.value.find((o: MultiSelectOption) => o.value === v),
          );
        };
      },
      InputComponent: MultiSelectFilterInput,
      InputComponentProps: {
        options,
      },
    },
  ];
};
